import React, { useRef, useState } from "react";
import DownloadIcon from "../Assets/Icon/DownloadIcon";
import LoadingIcon from "../Assets/Icon/LoadingIcon";
import PauseIcon from "../Assets/Icon/PauseIcon";
import PlayIcon from "../Assets/Icon/PlayIcon";
import RepeatIcon from "../Assets/Icon/RepeatIcon";
const Player = ({ surah, reader, langto }) => {
  const playerTrack = useRef();
  const range = useRef();
  const [player, setPlayer] = useState({
    duration: { current: "0", max: "0" },
    loading: true,
    playing: false,
    loop: false,
  });
  return (
    <>
      <audio
        className="hidden"
        ref={playerTrack}
        src={`https://cdn.islamic.network/quran/audio-surah/128/${reader.identifier}/${surah.number}.mp3`}
        loop={player.loop}
        // autoPlay={}
        onLoadStart={() => {
          setPlayer({
            ...player,
            loading: true,
            playing: false,
          });
        }}
        onCanPlayThrough={(e) => {
          setPlayer({
            ...player,
            duration: { ...player.duration, max: e.target.duration },
            loading: false,
          });
        }}
        onPlay={() => {
          setPlayer({
            ...player,
            playing: true,
          });
        }}
        onPause={() => {
          setPlayer({
            ...player,
            playing: false,
          });
        }}
        onTimeUpdate={(e) => {
          setPlayer({
            ...player,
            duration: {
              ...player.duration,
              current: e.target.currentTime,
            },
            loading: false,
          });
          // range.current.value = e.target.currentTime;
        }}
        onSeeking={() => {
          setPlayer({
            ...player,
            loading: true,
          });
        }}
      ></audio>
      <section className="player sticky px-8 pt-2 pb-4 bottom-0 right-0 w-full bg-[#F5F7F9] rounded-t-[45px] rounded-b-2xl shadow flex flex-wrap gap-2 ">
        <div className="details text-[var(--MColor)] flex items-center justify-evenly w-full mb-2 mt-4 ">
          {/* <img src={quranIcon} alt="icon details" className=" h-[40px]" /> */}

          <div className="flex items-center gap-2">
            <div
              className="play-Puse flex shrink-0 w-16 h-16 rounded-3xl cursor-pointer items-center justify-center bg-white"
              onClick={() => {
                playerTrack.current.paused && playerTrack.current.duration
                  ? playerTrack.current.play()
                  : playerTrack.current.pause();
              }}
            >
              {player.loading ? (
                <LoadingIcon />
              ) : player.playing ? (
                <PauseIcon />
              ) : (
                <PlayIcon />
              )}
            </div>
            <h3 className="text-sm flex flex-col">
              <span className=" text-xl">
                {langto === "EN"
                  ? surah.name
                      .replace(/[\u064B-\u065F|\u06E1]/g, "")
                      .replaceAll("ٱ", "ا")
                      .replaceAll("ىٰ", "ى")
                      .replaceAll("مٰ", "م") + " "
                  : "Surah " + surah.englishName}
              </span>
              <span>
                {langto === "EN"
                  ? "صوت القارئ : " + reader.name
                  : " reader's voice : " + reader.englishName}
              </span>
            </h3>
          </div>
          <RepeatIcon
            onclick={() => {
              setPlayer({ ...player, loop: !player.loop });
            }}
            fill={player.loop ? "var(--MColor)" : "#232629"}
          />
        </div>
        {/* <div className="track flex items-center gap-4 w-full mb-4">
          <span className="timer whitespace-nowrap shrink-0 w-10 notranslate">
            {`
             ${
               // extract hours
               Math.floor(player.duration.max / 60) > 60
                 ? `${Math.floor(player.duration.current / 60 / 60)}:${
                     // extract mints
                     Math.floor((player.duration.current / 60) % 60) > 9
                       ? Math.floor((player.duration.current / 60) % 60)
                       : "0" + Math.floor((player.duration.current / 60) % 60)
                   }`
                 : Math.floor(player.duration.current / 60)
             }:${
              // extract sec
              Math.floor(player.duration.current % 60) > 9
                ? Math.floor(player.duration.current % 60)
                : "0" + Math.floor(player.duration.current % 60)
            }
            `}
          </span>
          <input
            step=".01"
            className="w-full"
            style={{
              backgroundSize:
                (player.duration.current * 100) / player.duration.max +
                "% 100%",
            }}
            type="range"
            max={Math.round(player.duration.max)}
            ref={range}
            onChange={(e) => {
              playerTrack.current.currentTime = e.target.value;
              setPlayer({
                ...player,
                duration: {
                  ...player.duration,
                  current: e.target.value,
                },
              });
            }}
          />
          {isFinite(player.duration.max) && (
            <span className="maxTimer shrink-0 w-10 notranslate">
              {
                // extract hours
                Math.floor(player.duration.max / 60) > 60
                  ? `${Math.floor(player.duration.max / 60 / 60)}:${
                      // extract mints
                      Math.floor((player.duration.max / 60) % 60) > 9
                        ? Math.floor((player.duration.max / 60) % 60)
                        : "0" + Math.floor((player.duration.max / 60) % 60)
                    }`
                  : Math.floor(player.duration.max / 60)
              }
              :
              {
                // extract sec
                Math.floor(player.duration.max % 60) > 9
                  ? Math.floor(player.duration.max % 60)
                  : "0" + Math.floor(player.duration.max % 60)
              }
            </span>
          )}
        </div> */}
      </section>
    </>
  );
};

export default Player;
